/**
 * @generated SignedSource<<b8dee049181df17a0889f8e9242220ba>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "HomePage_platform",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "subtitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "homeLogoBackgroundColor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "enableComplexMenu",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "PlatformLogos",
      "kind": "LinkedField",
      "name": "logos",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "home",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "SimpleMenuMainNavigation_platform"
    }
  ],
  "type": "Platform",
  "abstractKey": null
};

node.hash = "7a0ee5c5ef4e087397fe6794fb076105";

module.exports = node;
